/**
 * ML Kit не существует в вебе (стори 13.5). Заглушка отвечает «лиц не найдено»,
 * чтобы редактор в вебе работал: маску можно поставить и подвинуть руками,
 * а автопривязка по лицу просто недоступна.
 */
type FaceDetectionOptions = {
  landmarkMode?: 'all' | 'none';
  contourMode?: 'all' | 'none';
  performanceMode?: 'fast' | 'accurate';
};

type Face = {
  frame: { left: number; top: number; width: number; height: number };
  rotationX?: number;
  rotationY?: number;
  rotationZ?: number;
  landmarks?: Record<string, { position: { x: number; y: number } }>;
};

const FaceDetection = {
  async detect(_uri: string, _options?: FaceDetectionOptions): Promise<Face[]> {
    return [];
  },
};

export default FaceDetection;
